import { render, staticRenderFns } from "./invoiceHistory.vue?vue&type=template&id=2c5d669b&scoped=true"
import script from "./invoiceHistory.vue?vue&type=script&lang=js"
export * from "./invoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./invoiceHistory.vue?vue&type=style&index=0&id=2c5d669b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d669b",
  null
  
)

export default component.exports